import 'velocity-animate';
import 'velocity-animate/velocity.ui';
import { velocityHelpers } from 'velocity-react';

export const OPACITY_DISABLED = 0.2;
export const DURATION_OPACITY_TOGGLE = 300;
export const DURATION_ANIMATED_NUMBER = 750;
export const DURATION_DROPDOWN_TOGGLE = 200;

export const transitionDisableToggleProps = show => ({
  animation: { opacity: show ? 1 : OPACITY_DISABLED },
  duration: DURATION_OPACITY_TOGGLE
});

export const transitionHideToggleProps = show => ({
  animation: { opacity: show ? 1 : 0 },
  duration: DURATION_OPACITY_TOGGLE
});

const Animations = {
  InDown: velocityHelpers.registerEffect({
    calls: [
      ['slideDown', 1, { easing: 'ease-out' }],
      [{ opacity: 1 }, 1, { easing: 'ease-out' }]
    ]
  }),
  InRight: velocityHelpers.registerEffect({
    calls: [
      ['slideDown', 1, { easing: 'ease-out' }],
      [{ translateX: 0, opacity: 1 }, 1, { easing: 'ease-out' }]
    ]
  }),
  InLeft: velocityHelpers.registerEffect({
    calls: [
      ['slideDown', 1, { easing: 'ease-out' }],
      [{ translateX: 0, opacity: 1 }, 1, { easing: 'ease-out' }]
    ]
  }),
  OutUp: velocityHelpers.registerEffect({
    calls: [
      [{ opacity: 0 }, 1, { easing: 'ease-out' }],
      ['slideUp', 1, { easing: 'ease-out' }]
    ]
  }),
  OutLeft: velocityHelpers.registerEffect({
    calls: [
      [{ translateX: '-=30', opacity: 0 }, 1, { easing: 'ease-out' }],
      ['slideUp', 1, { easing: 'ease-out' }]
    ]
  }),
  OutRight: velocityHelpers.registerEffect({
    calls: [
      [{ translateX: '+=30', opacity: 0 }, 1, { easing: 'ease-out' }],
      ['slideUp', 1, { easing: 'ease-out' }]
    ]
  })
};

const baseStagger = {
  stagger: 125,
  duration: 300
};

export const slideDownInRight = {
  ...baseStagger,
  animation: Animations.InRight,
  style: {
    // Since we're staggering, we want to keep the display at "none" until Velocity runs
    // the display attribute at the start of the animation.
    display: 'none'
  }
};

export const slideUpOutLeft = {
  ...baseStagger,
  animation: Animations.OutLeft,
  stagger: 0
};

export const slideDownInLeft = {
  ...slideDownInRight,
  animation: Animations.InLeft
};

export const slideUpOutRight = {
  ...slideUpOutLeft,
  animation: Animations.OutRight
};

export const slideDownIn = {
  ...baseStagger,
  animation: Animations.InDown,
  style: {
    // Since we're staggering, we want to keep the display at "none" until Velocity runs
    // the display attribute at the start of the animation.
    display: 'none'
  }
};

export const slideUpOut = {
  ...baseStagger,
  animation: Animations.OutUp
};
